import { r as s, h as e, H as l, g as d } from "./main-bb89b2f2.js";
import "vue";
const c = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}:host{display:block}.cardContainer{-webkit-user-select:none;-moz-user-select:none;user-select:none}.static{position:static}.m-0{margin:var(--spacing-0)}.box-border{box-sizing:border-box}.flex{display:flex}.h-full{height:100%}.w-full{width:100%}.flex-grow{flex-grow:1}.flex-col{flex-direction:column}.overflow-x-hidden{overflow-x:hidden}.border{border-width:1px}.border-solid{border-style:solid}.border-gray-300{border-color:var(--color-neutral-steel-300)}.bg-white{background-color:var(--color-white)}.p-0{padding:var(--spacing-0)}.p-4{padding:var(--spacing-4)}", h = c, b = class {
  constructor(t) {
    s(this, t), this.width = "100%", this.height = "100%", this.minHeight = "auto", this.contentHeight = "auto";
  }
  render() {
    const t = this.hostElement.querySelector('[slot="header"]') != null, r = this.hostElement.querySelector('[slot="footer"]') != null, o = {
      width: this.width,
      height: this.height,
      minHeight: this.minHeight
    }, i = {
      cardContainer: !0,
      "overflow-x-hidden": !0,
      "flex flex-col w-full h-full m-0 p-0": !0,
      "box-border border border-solid border-gray-300 bg-white": !0
    }, a = {
      "p-4": !0
    }, n = {
      height: this.contentHeight
    };
    return e(l, { key: "4562fb906554bd0fa74bc76b29d11bb8ef2fc034", style: o }, e("div", { key: "9018fc5c783717c94a9eb2533712a46557ccc22d", class: i }, t && e("slot", { key: "5617bcfbdd87f358c726aea10a7527972511e95d", name: "header" }), e("div", { key: "be6a6a2f48cdde6da69ec233a1c38a100fcc0e26", class: a, style: n }, e("slot", { key: "d027cc7aa9b743df2cab11234e6d633f2e5349b8", name: "content" })), e("div", { key: "482cdfe38b7aa9c604f2745afd847af4ffc10b07", class: "flex-grow" }), r && e("slot", { key: "03968c7bac36440f943e56506ae315a2715b827b", name: "footer" })));
  }
  get hostElement() {
    return d(this);
  }
};
b.style = h;
export {
  b as patternlib_dashboard_card
};
